import React from 'react';
import PaymentForm from '../components/PaymentForm';

const Payment = () => {
  return <PaymentForm />;
};

export default Payment; 